export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9581.22931d6b.jpg";